
import {filter} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router, NavigationStart } from '@angular/router';


export interface OpenGraphMetadata {
    title? : string;
    type? : string;
    description? : string;
    url? : string;
    locale? : string;
    localeAlternate? : string;
    siteName? : string;

    image? : string;
    imageType? : string;
    imageWidth? : number;
    imageHeight? : number;

    audio? : string;
    audioType? : string;

    video? : string;
    videoWidth? : number;
    videoHeight? : number;
    videoType? : string;
}

@Injectable()
export class OpenGraph {
    constructor(
        private meta : Meta,
        private router : Router
    ) {
        this.router.events.pipe(filter(ev => ev instanceof NavigationStart)).subscribe(ev => {
            this.clearMetadata();
        })
    }

    public clearMetadata() {
        let tags = this.meta.getTags('property^="og:"');
        this.meta.removeTag('property^="og:"');
    }

    private setProperty(prop : string, value : any) {
        if (value === undefined)
            return;

        this.meta.addTag({
            property: `og:${prop}`,
            content: `${value}`
        })
    }
    public setMetadata(metadata : OpenGraphMetadata) {
        this.setProperty('title', metadata.title);
        this.setProperty('type', metadata.type);
        this.setProperty('description', metadata.description);
        this.setProperty('url', metadata.url);
        this.setProperty('locale', metadata.locale);
        this.setProperty('locale:alternate', metadata.localeAlternate);
        this.setProperty('site_name', metadata.siteName);

        this.setProperty('image', metadata.image);
        this.setProperty('image:type', metadata.imageType);
        this.setProperty('image:width', metadata.imageWidth);
        this.setProperty('image:height', metadata.imageHeight);

        this.setProperty('audio', metadata.audio);
        this.setProperty('audio:type', metadata.audioType);

        this.setProperty('video', metadata.video);
        this.setProperty('video:width', metadata.videoWidth);
        this.setProperty('video:height', metadata.videoHeight);
        this.setProperty('video:type', metadata.videoType);
    }
}